export const categories = [
    {
        name: 'Toys and games',
        translationKey: 'toysAndGames',
        url: '/shop/catalog/personal-care',
        products: 572,
        image: 'images/categories/imgToysCategory.jpg',
    },
    {
        name: 'Pet Supplies',
        translationKey: 'petSupplies',
        url: '/shop/catalog/engravers',
        products: 134,
        image: 'images/categories/imgPetCategory.jpg',
    },
    {
        name: 'Health and Personal Care',
        translationKey: 'healthAndPersonalCare',
        url: '/shop/catalog/personal-care',
        products: 301,
        image: 'images/categories/imgHealthPersonalCare.jpg',
    },
    {
        name: 'Seasonal',
        translationKey: 'seasonal',
        url: '/shop/catalog/seasonal',
        products: 79,
        image: 'images/categories/imgSeasonalCategory.jpg',
    },
    {
        name: 'Home and Kitchen',
        translationKey: 'homeAndKitchen',
        url: '/shop',
        products: 366,
        image: 'images/categories/imgHomeKitchen.jpg',
    },
    {
        name: 'Office Products',
        translationKey: 'officeProducts',
        url: '/shop',
        products: 81,
        image: 'images/categories/imgOfficeProducts.jpg',
    },
];
